import { IIcon } from '../../model';

export const question: IIcon = {
  id: 'QUESTION',
  svg: '<circle cx="5" cy="5" r="5" fill="#E4E4E4"/><path fill="#8F8F8F" d="M4.56 5.93c0-.27.03-.49.1-.65.07-.16.2-.34.41-.53.21-.2.34-.33.4-.41a.7.7 0 00.12-.4c0-.2-.05-.34-.15-.44-.1-.1-.24-.15-.43-.15a.64.64 0 00-.44.15.5.5 0 00-.16.4h-.77c0-.36.13-.65.38-.86a1.5 1.5 0 011-.31c.42 0 .75.1.99.3.23.22.35.5.35.88 0 .33-.16.66-.48.98l-.39.37c-.14.15-.21.37-.21.67h-.72zm-.06.95c0-.12.04-.22.12-.3a.44.44 0 01.32-.1c.13 0 .24.03.32.11.08.08.11.17.11.29 0 .11-.03.2-.11.28-.08.07-.18.11-.32.11s-.25-.04-.33-.11a.39.39 0 01-.1-.28z"/>',
};
